<main-header></main-header>
<main>
    <div class="container">
        <div class="top-part">
            <div class="breadcrumb">
                <import-navigator currentStep="dimensions"></import-navigator>
                <div class="wrap-text">
                    <b>
                        Define analysis dimensions
                    </b>
                    <span>
                        e.g. by “Country”, “Product”, etc.
                    </span>
                </div>
            </div>
        </div>
        <div class="middle-part set-up">
            <div class="current-status">
                <div class="left">
                    <div class="dot"></div>
                    <div class="dot green"></div>
                    <div class="dot"></div>
                </div>
                <div class="divider"></div>
                <div class="right">
                    <div class="wrap">
                        The columns selected below appear to be <b>redundant</b> numerical columns and will be excluded from the analysis <help-link helpId="23"></help-link>
                    </div>
                    <div class="wrap">
                        Click on a column if you’d like to include it as a dimension – click again to exclude it
                    </div>
                    <div class="wrap">
                        <button autofocus (click)="save()" [ngClass]="{'loading-small': loading, 'btn':true, 'btn-green':true, 'btn-small':true}">Continue</button>
                    </div>
                </div>
            </div>
            <div class="table-data">
                <table>
                    <thead>
                    <tr>
                        <th *ngFor="let col of columns" (click)="toggleSelect(col)" [ngClass]="{'eligible': col.isEligible, 'selected': col.isSelected, 'red-bg': (col.isBad && !col.isSelected)}">
                            <span *ngIf="col.wasSelectedBefore" class="icon-check">✓</span> {{col.name}}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="small-font">
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'selected': col.isSelected}">
                            <ng-container *ngIf="col.isNumerical">
                                <b class="green">#</b>,&nbsp;
                            </ng-container>
                            {{ displayRoughNum(col.uniqueValues) }}
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length">
                                <div class="gray">
                                    {{col.someVals[0]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 1">
                                <div class="gray">
                                    {{col.someVals[1]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 2">
                                <div class="gray">
                                    {{col.someVals[2]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 3">
                                <div class="gray">
                                    {{col.someVals[3]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{'eligible': col.isEligible, 'cell-color': true}">
                            <ng-container *ngIf="col.someVals && col.someVals.length > 4">
                                <div class="gray">
                                    {{col.someVals[4]}}
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</main>
